import dataType from '../dataType';

const matchingKeyEndpoint = {
    name: 'MatchingKey_EndPoint',
    type: dataType.string
};

export default matchingKeyEndpoint;
